import { Action, Dispatch } from 'redux';
import { batchApi } from '../apis';
import { UploadBatchDelimiterEnum, UploadBatchTypeEnum } from '../api-internal';
import { showFeedback } from '../feedback/feedbackReducer';
import { setProgress } from './dataUploadReducer';

export const uploadBatch =
  (type: UploadBatchTypeEnum, file: File, delimiter?: UploadBatchDelimiterEnum) =>
  async (dispatch: Dispatch): Promise<Action> => {
    try {
      dispatch(setProgress({ inProgress: true }));
      const batch = await batchApi.uploadBatch({ file, type, delimiter });
      dispatch(setProgress({ inProgress: false, uploaded: true }));
      return dispatch(
        showFeedback({
          message: `Data upload #${batch.id} started!`,
          success: true,
        })
      );
    } catch (error) {
      console.warn('Error uploading batch', error);
      return dispatch(
        showFeedback({
          message: 'Error uploading batch',
          success: false,
        })
      );
    }
  };
